var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgParent = function SvgParent(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 12",
    style: {
      enableBackground: "new 0 0 18 12"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    transform: "translate(34 -61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_731"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    className: "parent-icon",
    cx: -28.9,
    cy: 64.6,
    rx: 3.6,
    ry: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    className: "parent-icon",
    d: "M-34,72c1.3,1.3,8.9,1.3,10.2,0V72c0-1.6-1.3-2.9-2.9-2.9h-4.4C-32.7,69.1-34,70.4-34,72L-34,72 L-34,72L-34,72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_731-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-2",
    className: "parent-icon",
    cx: -19.9,
    cy: 67.1,
    r: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-2",
    className: "parent-icon",
    d: "M-23.3,72c0.9,0.9,5.9,0.9,6.8,0v0c0-1.1-0.9-1.9-1.9-1.9h-3C-22.4,70.1-23.3,70.9-23.3,72 C-23.3,72-23.3,72-23.3,72L-23.3,72L-23.3,72z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgParent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Parent.55661f043882f1ceef235bd7550f7709.svg";